import { render, staticRenderFns } from "./FieldAndPathTabs.vue?vue&type=template&id=d7ae42a6&scoped=true"
import script from "./FieldAndPathTabs.vue?vue&type=script&lang=ts"
export * from "./FieldAndPathTabs.vue?vue&type=script&lang=ts"
import style0 from "./FieldAndPathTabs.vue?vue&type=style&index=0&id=d7ae42a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ae42a6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7ae42a6')) {
      api.createRecord('d7ae42a6', component.options)
    } else {
      api.reload('d7ae42a6', component.options)
    }
    module.hot.accept("./FieldAndPathTabs.vue?vue&type=template&id=d7ae42a6&scoped=true", function () {
      api.rerender('d7ae42a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FieldAndPath/FieldAndPathTabs.vue"
export default component.exports